// 코인 이름 지정
export const COIN_NAME_TRI = 'TRI' as const;
export const COIN_NAME_SFL = 'SFL' as const;
export const COIN_NAME_NFT = 'NFT' as const;
export const COIN_NAME_POL = 'POL' as const;
export const COIN_NAME_USDT = 'USDT' as const;
